document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-smg-agency]').forEach(select=>{
    const form=select.closest('form');
    const conditional=form?.querySelector('[data-smg-agency-fields]');
    const sync=()=>{if(!conditional)return;const show=select.value==='Yes';conditional.hidden=!show;conditional.querySelectorAll('input').forEach(input=>input.required=show)};
    select.addEventListener('change',sync);sync();
  });
  document.querySelectorAll('form[data-smg-application]').forEach(form=>{
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      const button=form.querySelector('button[type="submit"]');
      const status=form.querySelector('[data-smg-status]');
      if(button)button.disabled=true;
      if(status){status.textContent='Submitting securely…';status.className='smg-form-status';}
      try{
        const source=new FormData(form);const outgoing=new FormData();
        const direct=['applicationType','fullName','email','phone','city','showPreference','instagram','portfolioUrl','website'];const details={};
        for(const [key,value] of source.entries()){
          if(value instanceof File){if(value.size)outgoing.append(key,value);continue;}
          if(key==='consent'){outgoing.set('consent','true');continue;}
          if(direct.includes(key)){outgoing.set(key,value);continue;}
          if(value)details[key]=value;
        }
        outgoing.set('details',JSON.stringify(details));
        const response=await fetch('https://smglobal-catwalk-world-tour.saminamughaltd.chatgpt.site/api/applications',{method:'POST',body:outgoing});
        const result=await response.json();if(!response.ok)throw new Error(result.error||'We could not submit your application.');
        form.reset();form.querySelectorAll('[data-smg-agency-fields]').forEach(el=>el.hidden=true);
        if(status){status.textContent='Thank you. Your submission has been received securely.';status.className='smg-form-status smg-form-status--success';}
      }catch(error){if(status){status.textContent=error.message||'Please try again.';status.className='smg-form-status smg-form-status--error';}}
      finally{if(button)button.disabled=false;}
    });
  });
});
